(() => {
  if (window.__vertaroSizeSystemInitialized) return;
  window.__vertaroSizeSystemInitialized = true;

  const STORAGE_KEY = 'vertaro-size-system';
  const VALID_SYSTEMS = ['US', 'UK', 'EU'];
  const EU_COUNTRIES = new Set([
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'
  ]);

  // Exact mapping from Vertaro's published Size Guide. US = US Men's.
  const SIZE_MAP = {
    36: { us: '4',   uk: '3.5' },
    37: { us: '5',   uk: '4.5' },
    38: { us: '6',   uk: '5.5' },
    39: { us: '6.5', uk: '6' },
    40: { us: '7',   uk: '6.5' },
    41: { us: '8',   uk: '7.5' },
    42: { us: '8.5', uk: '8' },
    43: { us: '9.5', uk: '9' },
    44: { us: '10',  uk: '9.5' },
    45: { us: '11',  uk: '10.5' },
    46: { us: '12',  uk: '11.5' }
  };

  let currentSystem = null;
  let scheduled = false;

  function getCountryCode() {
    return (document.querySelector('[data-vertaro-country]')?.dataset.vertaroCountry || '').toUpperCase();
  }

  function getDefaultSystem() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (VALID_SYSTEMS.includes(saved)) return saved;
    } catch (_) {}

    const country = getCountryCode();
    if (country === 'US' || country === 'CA') return 'US';
    if (country === 'GB') return 'UK';
    if (EU_COUNTRIES.has(country)) return 'EU';
    return 'EU';
  }

  function parseEU(value) {
    const match = String(value || '').trim().match(/(?:EU\s*)?(\d{2})(?:\.0)?/i);
    return match ? Number(match[1]) : null;
  }

  function visibleSize(eu, system) {
    if (!eu) return null;
    const mapped = SIZE_MAP[eu];

    // Never invent a conversion that is absent from Vertaro's own Size Guide.
    if (system === 'EU') return `EU ${eu}`;
    if (!mapped || !mapped[system.toLowerCase()]) return null;
    if (system === 'US') return `US ${mapped.us}`;
    if (system === 'UK') return `UK ${mapped.uk}`;
    return `EU ${eu}`;
  }

  function updatePicker(picker, system) {
    const sizeInput = Array.from(picker.querySelectorAll('fieldset input[data-option-name]')).find(
      (input) => (input.dataset.optionName || '').trim().toLowerCase() === 'size'
    );
    if (!sizeInput) return;

    const fieldset = sizeInput.closest('fieldset');
    if (!fieldset) return;

    picker.classList.add('vertaro-size-enhanced');
    fieldset.classList.add('vertaro-size-fieldset');

    let header = picker.querySelector('.vertaro-size-header');
    if (!header || header.nextElementSibling !== fieldset) {
      if (header) header.remove();
      header = document.createElement('div');
      header.className = 'vertaro-size-header';
      header.innerHTML = `
        <div class="vertaro-size-header__left">
          <span class="vertaro-size-title">Select Size:</span>
          <a class="vertaro-size-guide" href="/pages/size-guide">Size Guide</a>
        </div>
        <div class="vertaro-size-tabs" role="group" aria-label="Size system">
          <button type="button" class="vertaro-size-tab" data-size-system="US">US</button>
          <button type="button" class="vertaro-size-tab" data-size-system="UK">UK</button>
          <button type="button" class="vertaro-size-tab" data-size-system="EU">EU</button>
        </div>`;
      fieldset.before(header);

      header.querySelectorAll('.vertaro-size-tab').forEach((button) => {
        button.addEventListener('click', () => {
          currentSystem = button.dataset.sizeSystem;
          try { localStorage.setItem(STORAGE_KEY, currentSystem); } catch (_) {}
          updateAllPickers();
        });
      });
    }

    header.querySelectorAll('.vertaro-size-tab').forEach((button) => {
      const active = button.dataset.sizeSystem === system;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const inputs = Array.from(fieldset.querySelectorAll('input[data-option-name]'));
    let hiddenSelection = false;
    const visibleInputs = [];

    inputs.forEach((input) => {
      const eu = parseEU(input.value);
      const wrapper = input.closest('label');
      const text = wrapper?.querySelector('.variant-option__button-label__text');
      if (!wrapper || !text) return;
      const label = visibleSize(eu, system);
      const hidden = !label;
      wrapper.classList.toggle('vertaro-size-unmapped', hidden);
      wrapper.hidden = hidden;
      if (hidden && input.checked) hiddenSelection = true;
      if (!hidden) {
        visibleInputs.push(input);
        if (text.textContent !== label) text.textContent = label;
      }
    });

    if (hiddenSelection) {
      const next = visibleInputs.find((input) => !input.disabled && input.getAttribute('aria-disabled') !== 'true')
        || visibleInputs.find((input) => !input.disabled);
      if (next) next.click();
      else if (system !== 'EU') updatePicker(picker, 'EU');
    }
  }

  function updateAllPickers() {
    if (!currentSystem) currentSystem = getDefaultSystem();
    document.querySelectorAll('variant-picker').forEach((picker) => updatePicker(picker, currentSystem));
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateAllPickers();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllPickers, { once: true });
  } else {
    updateAllPickers();
  }

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
